import React from "react";
import "./LawLibraryV2.css";
import SearchBox from "../../components/Search";
import { useLibrary } from "../../context/LibraryContext";
import { useNavigate } from "react-router-dom";
import { stateImages } from "../eGazette/CoatOfArms";

export default function LawLibraryV2() {
  const { setLibraryId } = useLibrary();
  const navigate = useNavigate();

  const handleNavigation = (libraryId) => {
    setLibraryId(libraryId);
    navigate(`/law-library/search?library=${libraryId}&page=1`);
  };

  const handleDocumentNavigation = (documentId, libraryId) => {
    setLibraryId(libraryId);
    navigate(
      `/law-library/document?documentID=${documentId}&library=${libraryId}&page=1`
    );
  };

  const handleSearch = ({ searchQuery, limit = 10, keyword, offset = 0 }) => {
    setLibraryId(null);

    let globalPayload = {};

    if (keyword === "keyword") {
      globalPayload = {
        query: searchQuery,
        type: "content",
        modules: "lawlibrary",
        search: "keyword",
        limit,
        offset: 0,
      };
    } else {
      globalPayload = {
        query: searchQuery,
        type: keyword,
        limit,
        offset,
      };
    }
    const queryString = new URLSearchParams(globalPayload).toString();

    navigate(`/law-library/search?${queryString}`);
    // navigate("/law-library/search", { state: { globalPayload } });
  };

  return (
    <div>
      <div className="lawlibrary-body">
        <div style={{ padding: "0 25px" }}>
          <SearchBox
            ready={true}
            onSearch={handleSearch}
            placeholder={"Enter keyword to search"}
          />
        </div>
        <div className="lawlibrary2-content">
          <div className="lawlibrary2-table-row">
            <div className="lawlibrary2-table">
              <p className="lawlibrary2-heading">Principal Acts</p>
              <p className="lawlibrary2-row">
                English
                <span className="lawlibrary2-align-right">
                  <span
                    className="clickable"
                    onClick={() => handleNavigation(2)}
                  >
                    Updated
                  </span>
                  &nbsp;/&nbsp;
                  <span
                    className="clickable"
                    onClick={() => handleNavigation(1)}
                  >
                    Original
                  </span>
                </span>
              </p>
              <p className="lawlibrary2-row">
                Bahasa Malaysia
                <span className="lawlibrary2-align-right">
                  <span
                    className="clickable"
                    onClick={() => handleNavigation(8)}
                  >
                    Updated
                  </span>
                  &nbsp;/&nbsp;
                  <span
                    className="clickable"
                    onClick={() => handleNavigation(9)}
                  >
                    Original
                  </span>
                </span>
              </p>
            </div>
            <div className="lawlibrary2-table">
              <p className="lawlibrary2-heading">Constitution of Malaysia</p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(9267, 17);
                }}
              >
                Federal Constitution
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(9266, 18);
                }}
              >
                Perlembagaan Persekutuan
              </p>
            </div>
          </div>
          <div className="lawlibrary2-table-row">
            <div className="lawlibrary2-table">
              <p className="lawlibrary2-heading">Subsidiary Legislation</p>
              <p className="lawlibrary2-row">
                P.U.(A) - Rules, Regulations, Orders & By-Laws <br /> (English)
                <span className="lawlibrary2-align-right">
                  <span
                    className="clickable"
                    onClick={() => handleNavigation(12)}
                  >
                    Updated
                  </span>
                  &nbsp;/&nbsp;
                  <span
                    className="clickable"
                    onClick={() => handleNavigation(11)}
                  >
                    Original
                  </span>
                </span>
              </p>

              <p className="lawlibrary2-row">
                P.U.(A) - Rules, Regulations, Orders & By-Laws
                (Bahasa&nbsp;Malaysia)
                <span className="lawlibrary2-align-right">
                  <span
                    className="clickable"
                    onClick={() => handleNavigation(14)}
                  >
                    Updated
                  </span>
                  &nbsp;/&nbsp;
                  <span
                    className="clickable"
                    onClick={() => handleNavigation(13)}
                  >
                    Original
                  </span>
                </span>
              </p>

              <p className="lawlibrary2-row">
                P.U.(A) - Proclamations {" "}
                <span className="lawlibrary2-align-right">
                  <span
                    className="clickable"
                    onClick={() => handleNavigation(22)}
                  >
                    Original
                  </span>
                </span>
              </p>
              <p className="lawlibrary2-row">
                P.U.(B) - Enforcement Dates, Appointments & Others{" "}
                <span className="lawlibrary2-align-right">
                  <span
                    className="clickable"
                    onClick={() => handleNavigation(23)}
                  >
                    Updated
                  </span>
                </span>
              </p>
            </div>
            <div className="lawlibrary2-table">
              <p className="lawlibrary2-heading">Codes</p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(9119, 24);
                }}
              >
                National Land Code 1965
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(92120, 24);
                }}
              >
                National Land Code 2020
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(17741, 2);
                }}
              >
                Criminal Procedure Code
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(17864, 2);
                }}
              >
                Penal Code
              </p>
{/*               
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(92004, 25);
                }}
              >
                Malaysian Code on Take-overs and Mergers 2016
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(71039, 11);
                }}
              >
                Judges' Code of Ethics 2009
              </p> */}
            </div>
          </div>
          <div className="lawlibrary2-table-row">
            <div className="lawlibrary2-table">
              <p className="lawlibrary2-heading">
                Ordinances, Pre-1968 Acts & Enactments
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => handleNavigation(21)}
              >
                Updated
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => handleNavigation(20)}
              >
                Original
              </p>
            </div>
            <div className="lawlibrary2-table">
              <p className="lawlibrary2-heading">Court Rules</p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(9277, 15);
                }}
              >
                Rules of the Federal Court 1995
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(9276, 15);
                }}
              >
                Rules of the Court of Appeal 1994
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(76233, 15);
                }}
              >
                Rules of Court 2012
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(20601, 11);
                }}
              >
                Rules of the Special Court 1994
              </p>
            </div>
          </div>
          <div className="lawlibrary2-table-row">
            <div className="lawlibrary2-table">
              <p className="lawlibrary2-heading">State Legislation</p>
              <p className="lawlibrary2-row">
                
                <span className="lawlibrary2-align-center"><img height={'100px'} width={'100px'} src={stateImages[9]} alt={`Johor Logo`} className="gallery-image"/>
                <br/><center><b>JOHOR</b></center></span>
                <span className="lawlibrary2-align-right">
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(235)}
                    >
                      Syariah Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(236)}
                    >
                      Syariah Legislative Supplements
                    </span>
                  </div>
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(237)}
                    >
                      Civil Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(238)}
                    >
                      Civil Legislative Supplements
                    </span>
                  </div>
                </span>
              </p>
              <p className="lawlibrary2-row">
                
                <span className="lawlibrary2-align-center"><img height={'100px'} width={'100px'} src={stateImages[6]} alt={`Johor Logo`} className="gallery-image"/>
                <center><b>PERAK</b></center></span>
                <span className="lawlibrary2-align-right">
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(223)}
                    >
                      Syariah Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(224)}
                    >
                      Syariah Legislative Supplements
                    </span>
                  </div>
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(225)}
                    >
                      Civil Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(226)}
                    >
                      Civil Legislative Supplements
                    </span>
                  </div>
                </span>
              </p>
              <p className="lawlibrary2-row">
                
                <span className="lawlibrary2-align-center"><img height={'100px'} width={'100px'} src={stateImages[7]} alt={`Johor Logo`} className="gallery-image"/>
                <br/><center><b>KEDAH</b></center></span>
                <span className="lawlibrary2-align-right">
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(219)}
                    >
                      Syariah Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(220)}
                    >
                      Syariah Legislative Supplements
                    </span>
                  </div>
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(221)}
                    >
                      Civil Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(222)}
                    >
                      Civil Legislative Supplements
                    </span>
                  </div>
                </span>
              </p>
              <p className="lawlibrary2-row">
                
                <span className="lawlibrary2-align-center"><img height={'100px'} width={'100px'} src={stateImages[2]} alt={`Johor Logo`} className="gallery-image"/>
                <br/><center><b>PERLIS</b></center></span>
                <span className="lawlibrary2-align-right">
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(227)}
                    >
                      Syariah Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(228)}
                    >
                      Syariah Legislative Supplements
                    </span>
                  </div>
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(229)}
                    >
                      Civil Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(230)}
                    >
                      Civil Legislative Supplements
                    </span>
                  </div>
                </span>
              </p>
              <p className="lawlibrary2-row">
                
                <span className="lawlibrary2-align-center"><img height={'100px'} width={'100px'} src={stateImages[5]} alt={`Johor Logo`} className="gallery-image"/>
                <br/><center><b>KELANTAN</b></center></span>
                <span className="lawlibrary2-align-right">
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(247)}
                    >
                      Syariah Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(248)}
                    >
                      Syariah Legislative Supplements
                    </span>
                  </div>
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(249)}
                    >
                      Civil Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(250)}
                    >
                      Civil Legislative Supplements
                    </span>
                  </div>
                </span>
              </p>
              <p className="lawlibrary2-row">
                
                <span className="lawlibrary2-align-center"><img height={'100px'} width={'100px'} src={stateImages[12]} alt={`Johor Logo`} className="gallery-image"/>
                <br/><center><b>PULAU PINANG</b></center></span>
                <span className="lawlibrary2-align-right">
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(211)}
                    >
                      Syariah Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(212)}
                    >
                      Syariah Legislative Supplements
                    </span>
                  </div>
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(213)}
                    >
                      Civil Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(214)}
                    >
                      Civil Legislative Supplements
                    </span>
                  </div>
                </span>
              </p>
              <p className="lawlibrary2-row">
                
                <span className="lawlibrary2-align-center"><img height={'100px'} width={'100px'} src={stateImages[11]} alt={`Johor Logo`} className="gallery-image"/>
                <br/><center><b>MELAKA</b></center></span>
                <span className="lawlibrary2-align-right">
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(217)}
                    >
                      Syariah Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(218)}
                    >
                      Syariah Legislative Supplements
                    </span>
                  </div>
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(215)}
                    >
                      Civil Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(216)}
                    >
                      Civil Legislative Supplements
                    </span>
                  </div>
                </span>
              </p>
              <p className="lawlibrary2-row">
                
                <span className="lawlibrary2-align-center"><img height={'100px'} width={'100px'} src={stateImages[13]} alt={`Johor Logo`} className="gallery-image"/>
                <br/><center><b>SARAWAK</b></center></span>
                <span className="lawlibrary2-align-right">
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(251)}
                    >
                      Syariah Ordinances
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(252)}
                    >
                      Syariah Legislative Supplements
                    </span>
                  </div>
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(253)}
                    >
                      Civil Ordinances
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(254)}
                    >
                      Civil Legislative Supplements
                    </span>
                  </div>
                </span>
              </p>
              <p className="lawlibrary2-row">
                
                <span className="lawlibrary2-align-center"><img height={'100px'} width={'100px'} src={stateImages[4]} alt={`Johor Logo`} className="gallery-image"/>
                <br/><center><b>NEGERI SEMBILAN</b></center></span>
                <span className="lawlibrary2-align-right">
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(231)}
                    >
                      Syariah Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(232)}
                    >
                      Syariah Legislative Supplements
                    </span>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(233)}
                    >
                      Civil Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(234)}
                    >
                      Civil Legislative Supplements
                    </span>
                  </div>
                </span>
              </p>
              <p className="lawlibrary2-row">
                
                <span className="lawlibrary2-align-center"><img height={'100px'} width={'100px'} src={stateImages[3]} alt={`Johor Logo`} className="gallery-image"/>
                <br/><center><b>SELANGOR</b></center></span>
                <span className="lawlibrary2-align-right">
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(207)}
                    >
                      Syariah Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(208)}
                    >
                      Syariah Legislative Supplements
                    </span>
                  </div>
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(210)}
                    >
                      Civil Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(209)}
                    >
                      Civil Legislative Supplements
                    </span>
                  </div>
                </span>
              </p>
              <p className="lawlibrary2-row">
                
                <span className="lawlibrary2-align-center"><img height={'100px'} width={'100px'} src={stateImages[8]} alt={`Johor Logo`} className="gallery-image"/>
                <br/><center><b>PAHANG</b></center></span>
                <span className="lawlibrary2-align-right">
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(239)}
                    >
                      Syariah Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(240)}
                    >
                      Syariah Legislative Supplements
                    </span>
                  </div>
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(241)}
                    >
                      Civil Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(242)}
                    >
                      Civil Legislative Supplements
                    </span>
                  </div>
                </span>
              </p>
              <p className="lawlibrary2-row">
                
                <span className="lawlibrary2-align-center"><img height={'100px'} width={'100px'} src={stateImages[1]} alt={`Johor Logo`} className="gallery-image"/>
                <br/><center><b>TERENGGANU</b></center></span>
                <span className="lawlibrary2-align-right">
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(243)}
                    >
                      Syariah Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(244)}
                    >
                      Syariah Legislative Supplements
                    </span>
                  </div>
                  <div style={{ textAlign: "right",marginBottom: "10px" }}>
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(245)}
                    >
                      Civil Enactments
                    </span>
                    &nbsp;/&nbsp;
                    <span
                      className="clickable"
                      onClick={() => handleNavigation(246)}
                    >
                      Civil Legislative Supplements
                    </span>
                  </div>
                </span>
              </p>
            </div>
            <div className="lawlibrary2-table">
              <p className="lawlibrary2-heading">
                Perintah-Perintah Am & Arahan Pentadbiran
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(79312, 19);
                }}
              >
                Peraturan-Peraturan Pegawai Awam (Pelantikan, Kenaikan Pangkat
                Dan Penamatan Perkhidmatan) 2012
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(5240, 19);
                }}
              >
                Elaun-Elaun Dalam Perkhidmatan 1974
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(5241, 19);
                }}
              >
                Cuti 1974
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(5242, 19);
                }}
              >
                Peraturan-Peraturan Pegawai Awam (Kelakuan dan Tatatertib) 1993
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(5236, 19);
                }}
              >
                Rumah dan Bangunan Penjawat Kerajaan Awam 1974
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(5238, 19);
                }}
              >
                Perubatan 1974
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(5237, 19);
                }}
              >
                Waktu Bekerja dan Lebih Masa 1974
              </p>
              <p
                className="lawlibrary2-row clickable"
                onClick={() => {
                  handleDocumentNavigation(69684, 10);
                }}
              >
                Arahan Perbendaharaan
              </p>

              <div className="lawlibrary2-table" style={{ marginTop: "10vh" }}>
                <p className="lawlibrary2-heading">Forms And Cause Papers</p>
                <p
                  className="lawlibrary2-row clickable"
                  onClick={() => navigate("search?page=1&library=426")}
                >
                  Federal
                </p>
                <p className="lawlibrary2-row clickable"
                  onClick={() => navigate("search?page=1&library=427")}>
                Johor
                </p>
                <p className="lawlibrary2-row clickable"
                  onClick={() => navigate("search?page=1&library=431")}>
                Perak
                </p>
                <p className="lawlibrary2-row clickable"
                  onClick={() => navigate("search?page=1&library=433")}>
                Kedah
                </p>
                <p className="lawlibrary2-row clickable"
                  onClick={() => navigate("search?page=1&library=435")}>
                Kelantan
                </p>
                <p className="lawlibrary2-row clickable"
                  onClick={() => navigate("search?page=1&library=432")}>
                Pulau Pinang
                </p>
                <p className="lawlibrary2-row clickable"
                  onClick={() => navigate("search?page=1&library=428")}>
                Melaka
                </p>
                <p className="lawlibrary2-row clickable"
                  onClick={() => navigate("search?page=1&library=438")}>
                Sarawak
                </p>
                <p className="lawlibrary2-row clickable"
                  onClick={() => navigate("search?page=1&library=429")}>
                Negeri Sembilan
                </p>
                <p className="lawlibrary2-row clickable"
                  onClick={() => navigate("search?page=1&library=430")}>
                Selangor
                </p>
                <p className="lawlibrary2-row clickable"
                  onClick={() => navigate("search?page=1&library=437")}>
                Pahang
                </p>
                <p className="lawlibrary2-row clickable"
                  onClick={() => navigate("search?page=1&library=436")}>
                Terengganu
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
